export default __webpack_public_path__ + "static/media/CCF.7a11929d.jpg";